/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [],
        name: "AccessControlBadConfirmation",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        name: "AccessControlEnforcedDefaultAdminDelay",
        type: "error",
    },
    {
        inputs: [],
        name: "AccessControlEnforcedDefaultAdminRules",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "defaultAdmin",
                type: "address",
            },
        ],
        name: "AccessControlInvalidDefaultAdmin",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "neededRole",
                type: "bytes32",
            },
        ],
        name: "AccessControlUnauthorizedAccount",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
        ],
        name: "AddressEmptyCode",
        type: "error",
    },
    {
        inputs: [],
        name: "AmountMustBeGreaterThanZero",
        type: "error",
    },
    {
        inputs: [],
        name: "CantRenounceOwnerRole",
        type: "error",
    },
    {
        inputs: [],
        name: "ContractAlreadySet",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "ERC1967InvalidImplementation",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC1967NonPayable",
        type: "error",
    },
    {
        inputs: [],
        name: "EnforcedPause",
        type: "error",
    },
    {
        inputs: [],
        name: "ExpectedPause",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedCall",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedToGetAssetDecimals",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedToTransfer",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "contractAddress",
                type: "address",
            },
        ],
        name: "InvalidContractAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidInitialization",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "InvalidRoleAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "NotInitializing",
        type: "error",
    },
    {
        inputs: [],
        name: "ReentrancyGuardReentrantCall",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "bits",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "SafeCastOverflowedUintDowncast",
        type: "error",
    },
    {
        inputs: [],
        name: "UUPSUnauthorizedCallContext",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "slot",
                type: "bytes32",
            },
        ],
        name: "UUPSUnsupportedProxiableUUID",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DefaultAdminDelayChangeCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
            {
                indexed: false,
                internalType: "uint48",
                name: "effectSchedule",
                type: "uint48",
            },
        ],
        name: "DefaultAdminDelayChangeScheduled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DefaultAdminTransferCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint48",
                name: "acceptSchedule",
                type: "uint48",
            },
        ],
        name: "DefaultAdminTransferScheduled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Donate",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint64",
                name: "version",
                type: "uint64",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "initialOwner",
                type: "address",
            },
        ],
        name: "MUnityTrinityAaveInitialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "NewImplementation",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "representationToken",
                type: "address",
            },
        ],
        name: "RepresentationTokenSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "amountMinted",
                type: "uint256",
            },
        ],
        name: "Supply",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Withdraw",
        type: "event",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_INTERFACE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "acceptDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "beginDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "cancelDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
        ],
        name: "changeDefaultAdminDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdminDelay",
        outputs: [
            {
                internalType: "uint48",
                name: "",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdminDelayIncreaseWait",
        outputs: [
            {
                internalType: "uint48",
                name: "",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "donate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_unity",
                type: "address",
            },
            {
                internalType: "address",
                name: "_aavePool",
                type: "address",
            },
            {
                internalType: "address",
                name: "_yieldToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "initialOwner",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingDefaultAdmin",
        outputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingDefaultAdminDelay",
        outputs: [
            {
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "protocolPool",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "representationToken",
        outputs: [
            {
                internalType: "contract IERC20Mintable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "rollbackDefaultAdminDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_representationToken",
                type: "address",
            },
        ],
        name: "setRepresentationToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "supply",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalAssets",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "unityToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "yieldToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class MUnityTrinityAave__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
MUnityTrinityAave__factory.bytecode = _bytecode;
MUnityTrinityAave__factory.abi = _abi;
//# sourceMappingURL=MUnityTrinityAave__factory.js.map